import * as uuid from 'uuid';
import * as sessionStorage from 'shared/services/SessionStorage';
import { Observable } from 'rxjs/Observable';
import { paymentService } from './PaymentService';
import { cartService } from 'services/CartService';
import { langService } from './LangService';
import { enLang } from 'interfaces/IProductData';
import { enPaymentType } from 'enums/enPaymentType';
import { apiService } from 'shared/services';
import { enPaymentMethod } from 'enums/enPaymentMethod';

export class UserService {

  private lastData = '';

  constructor() { }

  getSSID(): Observable<string> {
    return sessionStorage.getValue('ssid', () => uuid.v4().replace(/\d/gi, ''));
  }

  setBasicUser(): Observable<any> {
    return paymentService.getCart()
      .combineLatest(cartService.getCart(), langService.getLang())
      .filter(([data, cart, lang]) => !!cart.transactionKey)
      .take(1)
      .switchMap(([data, cart, lang]) => {

        if (data.document && data.payment[0].paymentMethod !== enPaymentMethod.FREE) {
          data.personType = data.document.length === 14 ? 'J' : 'F';
        }

        if (lang === enLang.EN_US) {
          data.personType = 'E';
        }

        const body: any = {
          name: data.name,
          phone: data.phone,
          email: data.email,
          personType: data.personType || null
        };

        if (data.address && data.address.street) {
          body.address = {
            postalCode: data.address.postalCode,
            street: data.address.street,
            number: data.address.number,
            complement: data.address.complement || '',
            district: data.address.district,
            cityId: data.address.cityId
          };
        }

        if (cart.paymentType !== enPaymentType.FREE && lang !== enLang.EN_US) {
          body.document = data.document;
        }

        const tmpKey = JSON.stringify([data, cart.paymentType, lang]);

        if (tmpKey === this.lastData) {
          return Observable.empty();
        }

        this.lastData = tmpKey;

        return apiService.post(`/client/create/${cart.transactionKey}`, body);
      })
      .logError();
  }
}

// tslint:disable-next-line:variable-name
export const UserServiceFactory = () => new UserService();

export const userService = UserServiceFactory();


// WEBPACK FOOTER //
// ./src/services/UserService.ts